import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

/**
 * Lightweight public-branding cache. Fetches logo + company_name + hero from
 * /api/settings/public (no auth required). Exposes a `refresh()` so the
 * Settings page can trigger an instant sidebar+login update right after save.
 */
const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({ app_logo_data: "", company_name: "XTRA-OMS", login_hero_data: "" });
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setBranding({
        app_logo_data: data?.app_logo_data || "",
        company_name: data?.company_name || "XTRA-OMS",
        login_hero_data: data?.login_hero_data || "",
      });
    } catch { /* endpoint is public; swallow network blips */ }
    finally { setLoaded(true); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <BrandingContext.Provider value={{ ...branding, loaded, refresh: load }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error("useBranding must be within BrandingProvider");
  return ctx;
}
